import { Icon, SvgUndo } from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import { watchAgain } from 'creators/videoPlayer';

import ControlBarButton from '../control-bar-button';

export default function WatchAgainButton(props) {
  const dispatch = useDispatch();

  const handleWatchAgain = () => {
    dispatch(watchAgain());
  };

  return (
    <ControlBarButton
      className="video-player-watch-again-button"
      hoverTagText="Watch Again"
      seeking={props.seeking}
      onClick={handleWatchAgain}
      addLeftMargin="16px"
    >
      <Icon
        color="white"
        className="control-bar-button-icon"
        icon={<SvgUndo />}
      />
    </ControlBarButton>
  );
}
